/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    AgencyAutocompleteFilter,
    AgencyAutocompleteFilterFromJSON,
    AgencyAutocompleteFilterToJSON,
    AgencyAutocompleteResponseItemAutocompleteResult,
    AgencyAutocompleteResponseItemAutocompleteResultFromJSON,
    AgencyAutocompleteResponseItemAutocompleteResultToJSON,
    ProblemDetails,
    ProblemDetailsFromJSON,
    ProblemDetailsToJSON,
} from '../models';

export interface ApiAgencyAutocompletePostRequest {
    agencyAutocompleteFilter?: AgencyAutocompleteFilter;
}

/**
 * no description
 */
export class AgencyAutocompleteApi extends runtime.BaseAPI {

    /**
     */
    async apiAgencyAutocompletePostRaw(requestParameters: ApiAgencyAutocompletePostRequest): Promise<runtime.ApiResponse<AgencyAutocompleteResponseItemAutocompleteResult>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/AgencyAutocomplete`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AgencyAutocompleteFilterToJSON(requestParameters.agencyAutocompleteFilter),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => AgencyAutocompleteResponseItemAutocompleteResultFromJSON(jsonValue));
    }

    /**
     */
    async apiAgencyAutocompletePost(requestParameters: ApiAgencyAutocompletePostRequest): Promise<AgencyAutocompleteResponseItemAutocompleteResult> {
        const response = await this.apiAgencyAutocompletePostRaw(requestParameters);
        return await response.value();
    }

}
